import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Academics", path: "/academics" },
  { label: "Campuses", path: "/campuses" },
  { label: "Admissions", path: "/admissions" },
  { label: "Events", path: "/events" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact", path: "/contact" }
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Announcement Bar */}
      <div className="bg-[#87111E] text-white text-center py-2 text-sm font-medium tracking-wide">
        <span>Admissions Open 2026–27  •  Nursery to Grade XII  •  </span>
        <a href="tel:7619305034" className="underline hover:text-[#F8C5C9] transition-colors">Call 7619305034</a>
      </div>

      {/* Main Navbar */}
      <nav
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white shadow-md"
            : "bg-white border-b border-gray-100"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2.5 shrink-0">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/fcc543bd-d42f-4ba5-bf4e-a8bc67b4a41b/images/de05625decb0b8b65cf662a6ed27ada0d7f575706f16a0d41c94b221dd2dac5e.jpeg"
                alt="TIPS Logo"
                className="w-10 h-10 rounded-sm object-cover shadow-sm border border-gray-200"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
              <div className="w-10 h-10 bg-[#9B1522] rounded-lg items-center justify-center shadow-sm hidden" aria-hidden="true">
                <span className="text-white font-extrabold text-lg leading-none">T</span>
              </div>
              <div className="hidden sm:block">
                <div className="font-extrabold text-gray-900 text-sm leading-tight tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  The Indian Public School
                </div>
                <div className="text-xs text-[#9B1522] font-semibold tracking-widest uppercase">
                  Bengaluru
                </div>
              </div>
            </Link>

            {/* Desktop Nav */}
            <div className="hidden xl:flex items-center gap-0.5">
              {navLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.path}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive(link.path)
                      ? "text-[#9B1522] bg-[#FDF5F6]"
                      : "text-gray-700 hover:text-[#9B1522] hover:bg-gray-50"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* CTA + Mobile Toggle */}
            <div className="flex items-center gap-3">
              <a
                href="tel:7619305034"
                className="hidden sm:flex items-center gap-1.5 text-sm text-[#9B1522] font-semibold hover:text-[#87111E] transition-colors"
              >
                <Phone size={15} />
                <span>7619305034</span>
              </a>
              <Link
                to="/admissions"
                className="hidden sm:inline-flex items-center bg-[#9B1522] hover:bg-[#87111E] text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors"
              >
                Apply Now
              </Link>
              <button
                className="xl:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
                onClick={() => setMobileOpen(!mobileOpen)}
              >
                {mobileOpen ? <X size={22} /> : <Menu size={22} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="xl:hidden bg-white border-t border-gray-100 shadow-lg">
            <div className="px-4 py-3 space-y-1 max-h-[70vh] overflow-y-auto">
              {navLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.path}
                  className={`block px-3 py-2.5 text-sm font-medium rounded-md ${
                    isActive(link.path) ? "text-[#9B1522] bg-[#FDF5F6]" : "text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="pt-3 pb-2">
                <Link
                  to="/admissions"
                  className="block w-full text-center bg-[#9B1522] text-white text-sm font-semibold px-4 py-2.5 rounded-lg hover:bg-[#87111E] transition-colors"
                >
                  Apply Now
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
